import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Close from '@material-ui/icons/Close';
import ListSubheader from '@material-ui/core/ListSubheader';
import Edit from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import Card from 'src/components/sharedComponents/Card/Card';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import { permitsList, minPermisos } from 'src/constants/permits';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import Search from 'src/components/sharedComponents/SearchInput';
import { Grid } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { SiCrowdsource } from 'react-icons/si';
import SaveIcon from '@material-ui/icons/Save';
import styles from '../styles';

const useStyles = makeStyles(styles);

const FontsControlPage = ({
  fonts,
  create,
  onCreate,
  onDelete,
  permisos,
  handleSubmit,
  handleUpdate,
  onChangeInput,
}) => {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [open2, setOpen2] = useState(false);

  const listRef = useRef(null);
  const classes = useStyles();
  const minValue = permisos[permitsList.REPORTE_DATASTUDIO];

  const handleClick = (event) => {
    event.preventDefault();
    setOpen2(!open2);
  };

  const handleClickList = (value) => {
    setOpen({ [value]: !open[value] ? !open[value] : !open[value] });
    setEdit({ [value]: !edit[value] ? edit[value] : !edit[value] });
  };

  const handleClickEdit = (value) => {
    setEdit({ [value]: !edit[value] ? !edit[value] : !edit[value] });
    // llamo al servicio de editar
  };

  const handleClickClose = (value) => {
    setOpen({ [value]: !open[value] ? !open[value] : !open[value] });
    setEdit({ [value]: !edit[value] ? !edit[value] : !edit[value] });
  };

  return (
    <main style={{ margin: '10px' }}>
      <CardTitle
        title="Administración de Fuentes"
        subTitle=" Permisos visualización y administración de Fuentes"
      />
      {minValue >= minPermisos.CREAR ? (
        <Card plain>
          <Button type="onSubmit" onClick={handleClick} color="danger">
            Crear Fuente
          </Button>
        </Card>
      ) : null}

      {/* Formulario de creación */}
      {open2 && (
        <Card>
          <form onSubmit={handleSubmit}>
            <CardBody>
              <CustomInput
                labelText="Nombre"
                id="Nombre"
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}
                inputProps={{
                  value: create.nombre || '',
                  onChange: (event) => onCreate(event, 'nombre'),
                  type: 'text',
                  autoComplete: 'off',
                }}
              />

              <CustomInput
                labelText="Descripción"
                id="Descripción"
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}
                inputProps={{
                  value: create.descripcion || '',
                  onChange: (event) => onCreate(event, 'descripcion'),
                  type: 'text',
                  autoComplete: 'off',
                }}
              />

              <CustomInput
                labelText="Url"
                id="Url"
                formControlProps={{
                  required: true,
                  fullWidth: true,
                }}
                inputProps={{
                  value: create.url || '',
                  onChange: (event) => onCreate(event, 'url'),
                  type: 'url',
                  autoComplete: 'off',
                }}
              />
            </CardBody>
            <CardFooter>
              <Button type="onSubmit" color="danger">
                Crear
              </Button>
            </CardFooter>
          </form>
        </Card>
      )}

      <Search handleSearch={onChangeInput} />
      <Card>
        <CardBody>
          <List
            subheader={<ListSubheader>Lista de Fuentes</ListSubheader>}
            className={classes.root}
            component="div"
            ref={listRef}
            key="Lista_Principal"
          >
            {' '}
            <div key="list_pkey">
              <form onSubmit={handleUpdate}>
                {fonts?.length === 0 ? (
                  <span>No hay Fuentes registradas.</span>
                ) : (
                  fonts?.map((value) => (
                    <div key={`key11${value.id}`}>
                      <ListItem
                        id={value.id}
                        key={`key${value.id}`}
                        aria-expanded={open}
                        button
                        onClick={() => handleClickList(value.id)}
                      >
                        <ListItemIcon>
                          <SiCrowdsource color="black" />
                          ,
                        </ListItemIcon>
                        <ListItemText
                          primary={value.nombre}
                          secondary={value.descripcion}
                        />
                        <Grid item>
                          {open[value.id] ? <ExpandLess /> : <ExpandMore />}
                        </Grid>
                      </ListItem>
                      <div key={`key2${value.id}`}>
                        <Collapse
                          in={open[value.id]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List key="nav2" component="div" disablePadding>
                            <ListItem className={classes.nested}>
                              <ListItemIcon>
                                <ArrowForwardIosIcon />
                              </ListItemIcon>
                              {!edit[value.id] && (
                                <ListItemText primary={value.url} />
                              )}
                              {edit[value.id] && (
                                <>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                      <CustomInput
                                        labelText="Nombre"
                                        id={value.id}
                                        value={value.nombre}
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) => onCreate(event, 'nombre'),
                                          type: 'text',
                                          autoComplete: 'off',
                                          defaultValue: value.nombre,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <CustomInput
                                        labelText="Url"
                                        id="name"
                                        value={value.url}
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) => onCreate(event, 'url'),
                                          type: 'url',
                                          autoComplete: 'off',
                                          defaultValue: value.url,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <CustomInput
                                        labelText="Descripción"
                                        id="name"
                                        value={value.descripcion}
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) => onCreate(event, 'descripcion'),
                                          type: 'text',
                                          autoComplete: 'off',
                                          defaultValue: value.descripcion,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </>
                              )}
                              <ListItemSecondaryAction
                                className={
                                  Object.values(edit).pop()
                                    ? classes.iconsEdit
                                    : null
                                }
                              >
                                {edit[value.id] !== true ? (
                                  <>
                                    {minValue >= minPermisos.ACTUALIZAR && (
                                      <>
                                        <IconButton
                                          color="primary"
                                          aria-label="editButton"
                                          component="span"
                                          onClick={() => handleClickEdit(value.id)}
                                        >
                                          <Edit
                                            className={
                                              classes.tableActionButtonIcon
                                            }
                                            style={{ color: 'blue' }}
                                          />
                                        </IconButton>
                                      </>
                                    )}
                                    {minValue >= minPermisos.ELIMINAR && (
                                      <IconButton
                                        color="primary"
                                        aria-label="editButton"
                                        component="span"
                                        onClick={() => onDelete(value.id)}
                                      >
                                        <DeleteIcon
                                          className={
                                            classes.tableActionButtonIcon
                                          }
                                          style={{ color: 'rgb(244, 67, 54)' }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                ) : null}
                                {edit[value.id] === true ? (
                                  <>
                                    <IconButton
                                      color="primary"
                                      aria-label="saveButton"
                                      component="span"
                                      onClick={() => handleUpdate(value.id)}
                                    >
                                      <SaveIcon
                                        className={
                                          classes.tableActionButtonIcon
                                        }
                                        style={{ color: ' #43a047' }}
                                      />
                                    </IconButton>
                                    <IconButton
                                      color="primary"
                                      aria-label="closeButto"
                                      component="span"
                                      onClick={() => handleClickClose(value.id)}
                                    >
                                      <Close
                                        className={
                                          classes.tableActionButtonIcon
                                        }
                                        style={{ color: 'rgb(244, 67, 54)' }}
                                      />
                                    </IconButton>
                                  </>
                                ) : null}
                              </ListItemSecondaryAction>
                            </ListItem>
                          </List>
                        </Collapse>
                      </div>
                    </div>
                  ))
                )}
              </form>
            </div>
          </List>
        </CardBody>
      </Card>
    </main>
  );
};

export default FontsControlPage;
